<template>
  <v-card style="height: 1400px;">
    <v-container grid-list-lg>
      <v-form
        ref="form"
        v-model="formValid"
        lazy-validation
      >
        <v-layout wrap>
          <v-flex md4>
            <v-text-field
              label="Author"
              v-model="author"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-btn
              @click="pickVideoFile"
              flat
            >
              <v-icon color="accent">videocam</v-icon>
              <strong class="accent--text">Change Video</strong>
            </v-btn>
            <input
              type="file"
              accept="video/*"
              ref="inputVideoFile"
              @change="onVideoFilePicked"
              :style="{ display: 'none' }"
            />
          </v-flex>
          <v-flex md4>
            <v-btn
              @click="pickImageFile"
              flat
            >
              <v-icon color="accent">photo_camera</v-icon>
              <strong class="accent--text">Change Photo</strong>
            </v-btn>
            <input
              type="file"
              accept="image/*"
              ref="inputImageFile"
              @change="onImageFilePicked"
              :style="{ display: 'none' }"
            />
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="CPD Points"
              v-model="cpdPoints"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Title"
              v-model="title"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Description"
              v-model="description"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Category"
              v-model="category"
              required
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field
              label="Minimum Score"
              v-model="minimumScore"
              required
            ></v-text-field>
          </v-flex>

        </v-layout>
        <h5>Video Segments</h5>
        <div v-for="(seg, i) in segmentData">
          <multiple-segment
            :index="i"
            :totalIndex="segmentData.length"
            :dataStartTime="seg.start_time"
            :dataEndTime="seg.end_time"
            :dataTitle="seg.title"
            :dataDescription="seg.description"
            :addToArray="addToArray"
            :removeToArray="removeToArray"
            :updateMultipleSegment="updateMultipleSegment"
          >

          </multiple-segment>
        </div>
        <v-layout>
          <v-btn
            @click="onSubmit"
            color="primary"
            :disabled="!formValid"
          >
            Submit
          </v-btn>
        </v-layout>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios'
import config from '../../../../configApi'
import multipleSegment from '@/components/admin/module/multipleSegment'
const apiUrl = config.apiUrl

export default {
  components: {
    multipleSegment
  },
  created () {
    this.token = localStorage.getItem('token')
    this.getUser()
  },
  data () {
    return {
      token: null,
      author: null,
      video: null,
      image: null,
      cpdPoints: null,
      title: null,
      description: null,
      category: null,
      minimumScore: null,
      formValid: true,
      userId: null,
      segmentData: [
        {
          start_time: '',
          end_time: '',
          time: '',
          description: ''
        }
      ]
    }
  },
  methods: {
    getUser () {
      axios.get(apiUrl + '/user').then((res) => {
        this.userId = res.data.id
      })
    },
    pickVideoFile () {
      this.$refs.inputVideoFile.click()
    },
    pickImageFile () {
      this.$refs.inputImageFile.click()
    },
    onVideoFilePicked (e) {
      let file
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x]
        if (file.type.indexOf('video') !== -1) {
          var reader = new FileReader()

          // reader.onload = e => {
          //   var img = new Image()
          //   img.src = e.target.result
          //   this.$refs.photo.src = img.src
          // }

          reader.readAsDataURL(file)
        }
      }
    },
    onImageFilePicked (e) {
      let file
      for (var x = 0, xlen = e.target.files.length; x < xlen; x++) {
        file = e.target.files[x]
        if (file.type.indexOf('image') !== -1) {
          var reader = new FileReader()

          // reader.onload = e => {
          //   var img = new Image()
          //   img.src = e.target.result
          //   this.$refs.photo.src = img.src
          // }

          reader.readAsDataURL(file)
        }
      }
    },
    onSubmit (e) {
      if (this.$refs.form.validate()) {
        var data = {
          author: this.author,
          cpd_points: this.cpdPoints,
          title: this.title,
          description: this.description,
          category: this.category,
          minimum_score: this.minimumScore,
          user_id: this.userId,
          video_segments: this.segmentData
        }

        var formData = new FormData()
        var videos = this.$refs.inputVideoFile.files
        for (var v = 0; v < videos.length; v++) {
          formData.append('video', videos.item(v))
        };
        var images = this.$refs.inputImageFile.files
        for (var i = 0; i < images.length; i++) {
          formData.append('image', images.item(i))
        };
        for (var prop in data) {
          if (Array.isArray(data[prop])) {
            data[prop].map(obj => {
              formData.append(`${prop}[]`, JSON.stringify(obj))
            })
          } else {
            formData.set(`${prop}`, `${data[prop]}`)
          }
        }
        // Native form submission is not yet supported
        axios.post(apiUrl + '/module', formData).then(e => {
          console.log(e)
        }).catch(e => {
          console.log(e)
        })
      }
    },
    addToArray () {
      let obj = {
        start_time: '',
        end_time: '',
        time: '',
        description: ''
      }
      this.segmentData.push(obj)
    },
    removeToArray (index) {
      this.$delete(this.segmentData, index)
    },
    updateMultipleSegment (obj, index) {
      this.segmentData[index] = obj
    }
  },
  props: {
    apiUrl: {
      type: String
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/addModuleForm.vue